/**
 * OVR is English only (decided 2026-10-13). The strings still live in
 * `locales/en/*.json` behind typed `t()` keys, so the copy stays in one place;
 * there is no picker and no other locale. (GMS, apps/gms, keeps its 10.)
 */

export const SUPPORTED_LOCALES = ["en"] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en";

/** The locale handed to Intl.DateTimeFormat / Intl.NumberFormat. */
export function intlLocaleFor(_locale: string): string {
	return DEFAULT_LOCALE;
}
